import React from 'react';
import { useSelector } from 'react-redux';
import { openInNewTab } from '../../../../utils/utils';
import Icon from '../../../ui/icons/Icon';
import iconsList from '../../../ui/icons/iconsList';
import charediImgLivComponent from '../../../../assets/FinalStage/charediImgLivComponent.png';
import classes from './FinalLiveVideoCharedi.module.css';

const FinalLiveVideoCharedi = () => {

  const { contentInfoJson } = useSelector((state) => state.contest)
  const { texts } = useSelector((state) => state.translate);

  return (
    <div className={classes.container}>
      <p className={classes.sectionTitle}> {texts.watchLiveBroadcastCharedi} </p>
      <div className={classes.content}>
        <div className={classes.rightSide}>
          <div className={classes.youtubeRow} onClick={() => openInNewTab(contentInfoJson?.final?.liveLink)}>
            <span className={classes.liveBadge}>
              <span className={classes.liveDot} />
              Live
            </span>
            <p className={classes.liveText}>{texts.theFinalBroadcastOnLiveCharedi}</p>
          </div>
          <div className={classes.zoomRow}>
            <span className={classes.zoomBadge}>
              <Icon name={iconsList.zoom} className={classes.zoomIcon} onClick={() => openInNewTab(contentInfoJson?.final?.zoomLink)} />
              <p className={classes.zoomText}>{texts.theFinalBroadcastOnZoomCharedi}</p>
            </span>
          </div>
        </div>
        <div className={classes.leftSide}>
          <img src={charediImgLivComponent} alt="live video" className={classes.liveVideo} />
        </div>
      </div>
    </div>
  );
};

export default FinalLiveVideoCharedi;
